<bn-loading-overlay></bn-loading-overlay>

<div class="container"  *ngIf="model">
<form  #formLimiteAgente="ngForm" class="form" >

		<div class="row">
			<div class="col">
				<h3>Limite por agente financeiro <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
			</div>
			<div class="col-auto">
				<button type="button" class="btn "
				[ngClass]="formLimiteAgente.form.pristine ? 'btn-primary' : 'btn-danger' "
				(click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
				</button>

				<button *ngIf="modoEdicao" type="button" class="btn btn-primary"
				[disabled]="formLimiteAgente.form.pristine || !formLimiteAgente.form.valid"
				(click)="salvar ()">Salvar
				</button>
			</div>
		</div>

   		<div class="row">
	      <div class="bn-form-group col-md-8" *ngIf="click == false; else autoComplete">
        	<label class="form-label" for="agenteFinanceiro"><b>Agente Financeiro&ensp;</b>
            <a [routerLink]="[]" (click)="toggle()">
              <i class="fas fa-toggle-off" placement="left-bottom"
              ngbTooltip="Buscar agente por CNPJ">
              </i>
            </a>
          </label>
          <select class="form-select" id="agenteFinanceiro" name="agenteFinanceiro"
                required #agenteFinanceiro="ngModel" [(ngModel)]="model.agenteFinanceiro.id"
                [disabled]="!modoEdicao || (model.id != null)" >
                  <option value="" 			></option>
                  <option [value]="agente.id" *ngFor="let agente of agentesFinanceiros">
                    {{agente.nome}} - ({{agente.cnpj | bnCnpj}})</option>
          </select>
        </div>
        <ng-template #autoComplete>
          <div class="bn-form-group col-md-8">
            <label class="form-label" for="agenteFinanceiro"><b>Agente Financeiro&ensp;</b>
              <a [routerLink]="[]" (click)="toggleBack()">
                <i class="fas fa-toggle-off" placement="left-bottom"
                ngbTooltip="Selecionar agente na ComboBox">
                </i>
              </a>
            </label>
            <input class="form-control" name="cnpj" bnMask="cnpj" [(ngModel)]="model.agenteFinanceiro.cnpj"
            [disabled]="!modoEdicao || (model.id != null)">
          </div>
        </ng-template>
	      <div class="bn-form-group col-md-4">
        	<label class="form-label" for="tranche"><b>Cesta</b></label>
	        <select class="form-select"  (change)="atribuiTranche($event.target.value)" id="tranche" name="tranche"
	        	required #agenteFinanceiro="ngModel" [(ngModel)]="model.ideTranche"
	        	[disabled]="!modoEdicao || (model.id != null) || ehFGBS" >
	            <option value="" 			></option>
	            <option [value]="tranche.id" *ngFor="let tranche of tranches">
	            	{{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
            </select>
	      </div>
	      <div class="bn-form-group col-md-4">
			<label class="form-label"><b>Limite de contratação</b></label>
			<input type="text" class="form-control text-end" id="valorLimiteTotal" name="valorLimiteTotal" [(ngModel)]="model.valorLimite.valorLimiteTotal" bnMask="MOEDA"
				[disabled]="!modoEdicao || ehFGBS" required />
		  </div>
	      <div class="bn-form-group col-md-4" *ngIf="trancheSelecionada?.indicadorLimiteEspecialHabilitado">
			<label class="form-label"><b>Limite Máximo</b></label>
			<input type="text" class="form-control text-end" id="valorLimiteMaximo" name="valorLimiteMaximo" [(ngModel)]="model.valorLimiteMaximo" bnMask="MOEDA"
				[disabled]="!modoEdicao || ehFGBS" required />
		  </div>
	    </div>
</form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

